export enum ENewbuildingStatus {
  /** Все объекты **/
  All = 'all',
  /** Строится **/
  InProgress = 'inProgress',
  /** Сдано **/
  IsFinished = 'isFinished',
}
